<template>
  <Button variant="outline" class="font-pmedium border-primary" @click="onClick">
    Admin
  </Button>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import * as Sentry from "@sentry/vue"
import { useAuth } from '@/composables/useAuth'
import { useToast } from '@/components/ui/toast/use-toast'

import { Button } from '@/components/ui/button'

const { login, isAuthenticated } = useAuth()
const router = useRouter()
const { toast } = useToast()
const isRedirecting = ref(false)

// Full-page redirect to Azure AD -- there's no password form anymore, ERS
// admin login is entirely handled by pomps-auth-api (Azure AD-backed, shared
// across Pomp's internal apps). Assigning which AD accounts can access ERS
// admin is managed in that shared portal, not here.
async function onClick() {
    if (isAuthenticated.value) {
        router.push({ name: 'Admin' })
        return
    }

    if (isRedirecting.value) return
    isRedirecting.value = true

    try {
        await login()
    } catch (error) {
        Sentry.captureException(error)
        isRedirecting.value = false
        toast({
            title: 'Login Failed',
            variant: 'destructive',
            description: 'Could not start login. Please try again.',
        })
    }
}
</script>